import types from './types';

const INITIAL_STATE = {
  isFetchingVersion: false,
  isFetchingContact: false,

  result: [],
};

const appPortalReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.GET_PORTAL_VERSION_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingVersion: true,
      };

    case types.GET_PORTAL_VERSION_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingVersion: false,
      };

    case types.GET_PORTAL_VERSION_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingVersion: false,
      };

    case types.GET_PORTAL_CONTACT_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingContact: true,
      };

    case types.GET_PORTAL_CONTACT_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingContact: false,
      };

    case types.GET_PORTAL_CONTACT_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingContact: false,
      };

    default:
      return state;
  }
};

export default appPortalReducer;
